import { CooldownTrainType } from "@ailenax-overlay/shared";
import { createRef, FC, ReactNode, RefObject, useEffect, useMemo, useState } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";

interface FinishedProps {
    train: CooldownTrainType;
    duration: number;
}

interface ScrollElement {
    element: ReactNode;
    weight: number;
    ref: RefObject<HTMLDivElement | null>;
}

const getTopDonators = (train: CooldownTrainType) => {
    const sums: Map<string, number> = new Map();
    train.entries.forEach((entry) => {
        const s = sums.get(entry.user) ?? 0;
        sums.set(entry.user, s + entry.amount);
    });

    const sorted = Array.from(sums.entries()).sort((a, b) => b[1] - a[1]);
    return sorted.map(s => s[0]).slice(0, 3)
}

export const Finished: FC<FinishedProps> = ({ train, duration }) => {
    const [index, setIndex] = useState(0);
    const elements: ScrollElement[] = useMemo(() => {
        const slides: ScrollElement[] = [
            { element: <span className="train-color">MEGA Support!</span>, weight: 10, ref: createRef() },
            { element: <div className="flex flex-col text-3xl gap-2 items-center justify-center"><span>Level { train.level }</span></div>, weight: 10, ref: createRef() },
        ];

        const topSupporters = getTopDonators(train);
        if (topSupporters[2]) {
            slides.push({ element: <div className="flex flex-col text-2xl gap-2 items-center justify-center"><span className="text-xl" style={{ color: "#9f2d00" }}>#3</span><span>{ topSupporters[2] }</span></div>, weight: 10, ref: createRef() });
        }
        if (topSupporters[1]) {
            slides.push({ element: <div className="flex flex-col text-2xl gap-2 items-center justify-center"><span className="text-xl" style={{ color: "#90a1b9" }}>#2</span><span>{ topSupporters[1] }</span></div>, weight: 10, ref: createRef() });
        }
        if (topSupporters[0]) {
            slides.push({ element: <div className="flex flex-col text-2xl gap-2 items-center justify-center"><span className="text-xl" style={{ color: "#efb100" }}>#1</span><span>{ topSupporters[0] }</span></div>, weight: 15, ref: createRef() });
        }

        return slides;
    }, [train]);

    const totalWeight = useMemo(() => {
        return elements.reduce((a, b) => a + b.weight, 0);
    }, [elements]);

    useEffect(() => {
        const t = setTimeout(() => {
            setIndex((index) => (index + 1) % elements.length);
        }, duration / totalWeight * elements[index].weight);

        return () => {
            clearTimeout(t);
        }
    }, [index, duration, totalWeight, elements]);

    return (
        <div className="w-[100%] h-[100%] px-3 flex flex-col justify-center items-center text-4xl">
            <SwitchTransition>
                <CSSTransition nodeRef={elements[index].ref} key={index} classNames="dono-train-state" timeout={1000}>
                    <div ref={elements[index].ref}>
                        { elements[index].element }
                    </div>
                </CSSTransition>
            </SwitchTransition>
        </div>
    );
}